import {
    Button,
    styled,
    Typography,
    Container as BaseContainer,
    FormLabel as BaseFormLabel,
} from "@material-ui/core";
import { Alert } from '@material-ui/lab';
import FullPageCircularProgress from "components/full-page-circular-progress";
import SectionGrid from "components/section-grid";
import { brand } from "../../../theme";

export const Container = styled(({ ...p }) =>
    <div {...p} />
)({
    background: brand.surface,
});

export const InnerContainer = styled(({ ...p }) =>
    <BaseContainer {...p} />
)(({ theme }) => ({
    marginBottom: theme.mixins.toolbar.minHeight,
    paddingBottom: theme.spacing(3),
    background: brand.surface,
}));

export const CancelButton = styled((p) =>
    <Button {...p} color="inherit">
        Cancel
    </Button>
)(({ theme }) => ({
    marginRight: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));

export const UpdateButton = styled(({ isSaving, ...p }: any) =>
    <Button {...p} color="inherit" disabled={isSaving || false}>
        {isSaving ? 'Updating...' : 'Update'}
    </Button>
)(({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));

export const CircularProgress = FullPageCircularProgress;

export const InformationMessage = styled(p =>
    <Alert
        elevation={6}
        variant="filled"
        severity="info"
        {...p}
    />
)(({ theme }) => ({
    marginBottom: theme.spacing(3)
}));

export const Section = SectionGrid;

export const BeerListCaption = styled(p =>
    <Typography variant="caption" {...p} />
)({});

/** Section heading used by every field card on the round form. Capitalised,
 *  small, secondary-text — matches the design's "section title" treatment. */
export const FormLabel = styled(p =>
    <BaseFormLabel {...p} />
)({
    fontSize: 12,
    fontWeight: 700,
    color: brand.textSec,
    letterSpacing: 0.8,
    textTransform: "uppercase",
    marginBottom: 8,
});
